<template>

  <b-container>
    <b-btn
      v-b-modal="'myModal'"
      class="modalButton">Submit a picture to the game</b-btn>

    <b-modal
      id="myModal"
      v-model="visible"
      :hide-footer="true"
    >

      <b-form
        v-if="visible"
        ref="form"
        :key="formKey"
        @submit.prevent="submit"
      >
        <b-form-group label="Name">
          <b-form-input
            v-model="name"
            required
            placeholder="Full Name"/>
        </b-form-group>

        <b-form-group label="Message">
          <b-form-textarea
            v-model="message"
            required
            placeholder="Message"/>
        </b-form-group>

        <b-form-group label="Photo">
          <!--<b-form-file-->
          <!--v-model="file"-->
          <!--placeholder="Choose a photo"-->
          <!--accept="image/*"-->
          <!--multiple-->
          <!--/>-->
          <!---->

          <PictureInput
            ref="pictureInput"
            :auto-toggle-aspect-ratio="true"
            width="600"
            height="600"
            margin="16"
            accept="image/jpeg,image/png"
            size="10"
            button-class="btn"
          />
        </b-form-group>
        <b-button
          :class="{
            disabled: loading
          }"
          type="submit"
          variant="primary"
          @click.prevent="submit">Submit</b-button>
        <div v-if="loading"> Loading... </div>
        <b-alert
          :show="success"
          variant="success">Thanks</b-alert>


      </b-form>
    </b-modal>

  </b-container>

</template>

<script>
import PictureInput from "vue-picture-input";
import FormData from "form-data";

export default {
  name: "UploadForm",
  components: {
    PictureInput
  },
  data() {
    return {
      visible: false,
      name: "",
      message: "",
      loading: false,
      success: false,
      formKey: 0
    };
  },
  methods: {
    async submit() {
      let form = this.$refs.form;
      if (form.reportValidity()) {
        const form = new FormData();

        let file = this.$refs.pictureInput.file;

        form.append("identifier", this.$store.state.player.identifier);
        form.append("name", this.name);
        form.append("message", this.message);
        form.append("image", file);

        this.loading = true;

        await this.$http.post("api/media/submit", form);
        this.loading = false;
        this.name = "";
        this.message = "";
        this.success = true;
        //this.$refs.pictureInput.removeImage();
        // this.$forceUpdate();
        this.formKey += 1;
      }
    }
  }
};
</script>

<style scoped>
.modalButton {
  margin: 15px;
}
form {
  margin-top: 20px;
  margin-bottom: 20px;
}
.form-group {
  //width: 100%;
  //background-color: rgba(200,200,200,.75);
}
.form-control {
  border: 0.3em dashed rgba(66, 66, 66, 0.15);
  //border-style: inset;
  //box-shadow: .3em dashed rgba(66,66,66,.15);
  background-color: rgba(200, 200, 200, 0.75);
  margin: 10px;
}

.b-form-group form-group legend {
  font-weight: bold !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadForm.vue